"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableContext = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var antd_1 = require("antd");
var lodash_1 = require("lodash");
var use_deep_compare_effect_1 = tslib_1.__importDefault(require("use-deep-compare-effect"));
var condition_1 = require("./components/filter/condition");
var callback_1 = tslib_1.__importDefault(require("./hooks/callback"));
var locale_1 = tslib_1.__importDefault(require("./locale"));
var types_1 = require("./types");
var utils_1 = require("./utils");
var TableContext = (0, react_1.createContext)({
    fetchingRecordsMsg: "Fetching records...",
    columnsObject: null,
    defaultSearch: "",
    filtersObject: null,
    id: "",
    onAddFilter: function () { },
    onCallback: undefined,
    onRemoveFilter: function () { },
    onSearch: function () { },
    onMultipleSort: function () { },
    sortable: false,
    style: {},
});
var TableProvider = function (_a) {
    var children = _a.children, id = _a.id, columns = _a.columns, onSearch = _a.onSearch, onMultipleSort = _a.onMultipleSort, defaultSort = _a.defaultSort, onCallback = _a.onCallback, onAddFilter = _a.onAddFilter, onRemoveFilter = _a.onRemoveFilter, sortable = _a.sortable, style = _a.style, filtersList = _a.filtersList, fetchingRecordsMsg = _a.fetchingRecordsMsg, setView = _a.setView, view = _a.view;
    var saveColumnsKey = "".concat(id, "-columns");
    var saveFiltersKey = "".concat(id, "-filters");
    var saveSearchSortKey = "".concat(id, "-sort-search");
    var initialColumns = Object.assign([], columns);
    var _b = (0, react_1.useState)(columns), tableColumns = _b[0], setTableColumns = _b[1];
    var _c = (0, react_1.useState)(false), openFilters = _c[0], setOpenFilter = _c[1];
    var _d = (0, react_1.useState)(defaultSort), multipleSort = _d[0], setMultipleSort = _d[1];
    var _e = (0, callback_1.default)([]), filters = _e[0], setFilters = _e[1];
    var _f = (0, react_1.useState)(""), activeKey = _f[0], setActiveKey = _f[1];
    var _g = (0, react_1.useState)(null), defaultSearch = _g[0], setDefaultSearch = _g[1];
    var _h = (0, react_1.useState)([]), savedFilter = _h[0], setSavedFilter = _h[1];
    var _j = (0, react_1.useState)(""), savedSort = _j[0], setSavedSort = _j[1];
    var _k = (0, react_1.useState)(""), savedSearch = _k[0], setSavedSearch = _k[1];
    var _l = (0, react_1.useState)(false), isFiltersLoaded = _l[0], setIsFiltersLoaded = _l[1];
    var onSortSearch = function (search, sortKeys) {
        if (!(0, lodash_1.isEmpty)(search)) {
            setDefaultSearch(search);
            onSearch(search, false);
        }
        if (!(0, lodash_1.isEmpty)(sortKeys)) {
            var sorts = sortKeys.split(",").map(function (key) {
                if (typeof key == "string" && key.startsWith("-")) {
                    return {
                        key: key.substring(1),
                        order: types_1.ORDERING.DESC,
                    };
                }
                return { key: key, order: types_1.ORDERING.ASC };
            });
            setMultipleSort(tslib_1.__spreadArray([], sorts, true));
            onMultipleSort(sorts, false);
        }
    };
    (0, use_deep_compare_effect_1.default)(function () {
        var _a;
        var localColumns = localStorage.getItem(saveColumnsKey);
        if (localColumns) {
            setTableColumns((0, utils_1.getOrderedColumns)((_a = JSON.parse(localColumns)) === null || _a === void 0 ? void 0 : _a.columns, columns));
        }
        else {
            setTableColumns(columns);
        }
        // Parse params in URL
        var params = (0, utils_1.fetchParamsInURL)();
        if (!(0, lodash_1.isEmpty)(params)) {
            var _b = (0, utils_1.urlParamsToFilters)(params, filtersList), columnsFilters = _b.columnsFilters, search = _b.search, sortKey = _b.sortKey;
            if (!(0, lodash_1.isEmpty)(columnsFilters)) {
                setOpenFilter(true);
                setFilters(tslib_1.__spreadArray([], columnsFilters, true));
                columnsFilters.map(function (v) {
                    var _a;
                    if (v.type === types_1.DATA_TYPE.DATETIME && ((_a = v === null || v === void 0 ? void 0 : v.value) === null || _a === void 0 ? void 0 : _a.length) === 2) {
                        (0, condition_1.onAddDateFilter)(onAddFilter, v.key, v.value, false, v.condition);
                    }
                    else {
                        onAddFilter(v.key, v.condition === types_1.FILTER_CONDITION.EQUALS ? "" : "__".concat(v.condition), v.value, false);
                    }
                });
            }
            onSortSearch(search, sortKey);
        }
    }, [columns, id, tableColumns.length]);
    (0, use_deep_compare_effect_1.default)(function () {
        var _a, _b;
        var localFilter = localStorage.getItem(saveFiltersKey);
        var localSort = localStorage.getItem(saveSearchSortKey);
        if (localFilter) {
            var saved = JSON.parse(localFilter);
            if (!(0, lodash_1.isEmpty)((_a = saved === null || saved === void 0 ? void 0 : saved.filters) === null || _a === void 0 ? void 0 : _a.data)) {
                setOpenFilter(true);
                if (!isFiltersLoaded) {
                    // parse date time occurrence in lists
                    var rows = (_b = saved.filters.data) === null || _b === void 0 ? void 0 : _b.map(function (filter) {
                        var _a, _b;
                        if (filter.type === types_1.DATA_TYPE.DATETIME && !(0, lodash_1.isEmpty)(filter.options)) {
                            return tslib_1.__assign(tslib_1.__assign({}, filter), { value: [(0, utils_1.parseDate)((_a = filter.options) === null || _a === void 0 ? void 0 : _a[0]), (0, utils_1.parseDate)((_b = filter.options) === null || _b === void 0 ? void 0 : _b[1])] });
                        }
                        return filter;
                    });
                    rows === null || rows === void 0 ? void 0 : rows.forEach(function (row) {
                        var index = filters.findIndex(function (filter) { return filter.key === row.key; });
                        if (index > -1) {
                            filters[index] = row;
                        }
                        else {
                            filters.push(row);
                        }
                    });
                    setSavedFilter((0, utils_1.convertDateToString)(filters));
                }
            }
            setIsFiltersLoaded(true);
            setFilters(tslib_1.__spreadArray([], filters, true), function () {
                filters.map(function (v) {
                    var _a;
                    if (v.type === types_1.DATA_TYPE.DATETIME && ((_a = v === null || v === void 0 ? void 0 : v.value) === null || _a === void 0 ? void 0 : _a.length) === 2) {
                        (0, condition_1.onAddDateFilter)(onAddFilter, v.key, v.value, false, v.condition);
                    }
                    else {
                        onAddFilter(v.key, v.condition === types_1.FILTER_CONDITION.EQUALS ? "" : "__".concat(v.condition), v.value, false);
                    }
                });
            });
        }
        if (localSort) {
            var searchSort = JSON.parse(localSort);
            if (searchSort) {
                setSavedSort(searchSort === null || searchSort === void 0 ? void 0 : searchSort.sort);
                setSavedSearch(searchSort === null || searchSort === void 0 ? void 0 : searchSort.search);
                onSortSearch(searchSort === null || searchSort === void 0 ? void 0 : searchSort.search, searchSort === null || searchSort === void 0 ? void 0 : searchSort.sort);
            }
        }
    }, [{ columns: tableColumns.length }]);
    (0, react_1.useEffect)(function () {
        if (onCallback) {
            onCallback.current = function (fn) {
                var columns = (0, utils_1.getExportableFields)(tableColumns);
                fn(columns, filters, multipleSort, defaultSearch);
            };
        }
    }, [filters, onCallback, multipleSort, defaultSearch, tableColumns]);
    var onToggleColumn = (0, react_1.useCallback)(function (val, column) {
        var updated = tableColumns.map(function (v) {
            return v.key == column.key ? Object.assign({}, v, { isVisible: val.target.checked }) : v;
        });
        setTableColumns(tslib_1.__spreadArray([], updated, true));
    }, [tableColumns]);
    var onReorderColumn = (0, react_1.useCallback)(function (result) {
        var _a, _b;
        if (((_a = result === null || result === void 0 ? void 0 : result.destination) === null || _a === void 0 ? void 0 : _a.index) === undefined || ((_b = result === null || result === void 0 ? void 0 : result.source) === null || _b === void 0 ? void 0 : _b.index) === undefined) {
            antd_1.message.error(locale_1.default.repositionFailedError);
            return;
        }
        var visibleColumns = tslib_1.__spreadArray([], tableColumns.filter(function (column) { return column.isVisible; }), true);
        var destination = visibleColumns.find(function (_, i) { var _a; return i == ((_a = result === null || result === void 0 ? void 0 : result.destination) === null || _a === void 0 ? void 0 : _a.index); });
        var source = visibleColumns.find(function (_, i) { var _a; return i == ((_a = result === null || result === void 0 ? void 0 : result.source) === null || _a === void 0 ? void 0 : _a.index); });
        var lines = tslib_1.__spreadArray([], tableColumns, true);
        if (destination && source) {
            var destinationIdx = lines.findIndex(function (col) { return col.key === destination.key; });
            var sourceIdx = lines.findIndex(function (col) { return col.key === source.key; });
            lines.splice(sourceIdx, 1);
            lines.splice(destinationIdx, 0, source);
        }
        setTableColumns(tslib_1.__spreadArray([], lines, true));
    }, [tableColumns]);
    var onResizeColumn = function (key, width) {
        tableColumns.forEach(function (column) {
            if (column.key == key) {
                column.width = width;
            }
        });
        setTableColumns(tslib_1.__spreadArray([], tableColumns, true));
        onPersistColumnsContextState();
    };
    var onRestoreColumn = function () {
        localStorage.removeItem(saveColumnsKey);
        setTableColumns(tslib_1.__spreadArray([], initialColumns, true));
        window.location.reload();
        antd_1.message.success(locale_1.default.columnRestored);
    };
    var onRestoreFilters = function () {
        localStorage.removeItem(saveFiltersKey);
        localStorage.removeItem(saveSearchSortKey);
        setFilters([]);
        setDefaultSearch(null);
        onMultipleSort([]);
        onRemoveFilter("no-keys", true);
        antd_1.message.success(locale_1.default.filtersRestored);
    };
    var getSortKey = function (sort) {
        return sort === null || sort === void 0 ? void 0 : sort.map(function (v) {
            if (v.order === types_1.ORDERING.DESC) {
                return "-".concat(v.key);
            }
            return v.key;
        }).toString();
    };
    var hasFilterBeenSaved = (0, lodash_1.isEqual)((0, utils_1.convertDateToString)(filters), savedFilter) &&
        (0, lodash_1.isEqual)(getSortKey(multipleSort), savedSort) &&
        (0, lodash_1.isEqual)(defaultSearch, savedSearch);
    var onPersistFiltersContextState = function () {
        var state = {
            filters: {
                data: filters,
            },
        };
        localStorage.setItem(saveFiltersKey, JSON.stringify(state));
        setSavedFilter((0, utils_1.convertDateToString)(filters));
        setSavedSearch(defaultSearch);
        setSavedSort(getSortKey(multipleSort));
        localStorage.setItem(saveSearchSortKey, JSON.stringify({
            sort: getSortKey(multipleSort),
            search: defaultSearch,
        }));
        antd_1.message.success(locale_1.default.filtersSaved);
    };
    var onPersistColumnsContextState = function () {
        var state = {
            columns: (0, utils_1.getOrderedColumnsKeys)(tableColumns),
        };
        localStorage.setItem(saveColumnsKey, JSON.stringify(state));
    };
    var columnsObject = {
        initial: initialColumns,
        data: tableColumns,
        onToggle: onToggleColumn,
        onReorder: onReorderColumn,
        onRestore: onRestoreColumn,
        onResize: onResizeColumn,
        onPersistContextState: onPersistColumnsContextState,
    };
    var filtersObject = {
        list: filtersList,
        isOpen: openFilters,
        activeKey: activeKey,
        data: filters,
        onOpen: setOpenFilter,
        onAppend: setFilters,
        onSetActiveKey: setActiveKey,
        onRestore: onRestoreFilters,
        onPersistContextState: onPersistFiltersContextState,
        filterSaved: hasFilterBeenSaved,
    };
    return (react_1.default.createElement(TableContext.Provider, { value: {
            id: id,
            fetchingRecordsMsg: fetchingRecordsMsg,
            columnsObject: columnsObject,
            filtersObject: filtersObject,
            defaultSearch: defaultSearch,
            onSearch: function (value) {
                if (!value) {
                    setDefaultSearch(value);
                    return;
                }
                onSearch(value);
            },
            onMultipleSort: onMultipleSort,
            multipleSort: multipleSort,
            setMultipleSort: setMultipleSort,
            onAddFilter: onAddFilter,
            onRemoveFilter: onRemoveFilter,
            onSwitchView: function (k) {
                setView(k);
            },
            view: view,
            sortable: sortable,
            style: style,
        } }, children));
};
exports.default = TableProvider;
var useTableContext = function () { return (0, react_1.useContext)(TableContext); };
exports.useTableContext = useTableContext;
//# sourceMappingURL=context.js.map